import OrganisationsTable from "./OrganisationsTable";

export default OrganisationsTable